import { render, staticRenderFns } from "./SideEventbar.vue?vue&type=template&id=6c466338&scoped=true&"
import script from "./SideEventbar.vue?vue&type=script&lang=js&"
export * from "./SideEventbar.vue?vue&type=script&lang=js&"
import style0 from "./SideEventbar.vue?vue&type=style&index=0&id=6c466338&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c466338",
  null
  
)

export default component.exports